import { BNBox } from "@bn-monorepo/js-packages";
import { StringContext } from "../../StringContext";
import { useContext } from "react";
import ErrorBoundary from "../ErrorBoundary/ErrorBoundary";
import { useTheme } from "@mui/material/styles";
import Button from "../CmsDocuments/SectionPage/components/Button/Button";

interface Props {
  cmsContent: any;
}
const CTAButton: React.FC<Props> = (props) => {
  const { cmsContent } = props;
  const strings = useContext(StringContext);
  const theme = useTheme();

  return (
    <ErrorBoundary errorMesage={strings.general_errorboundary_message}>
      {cmsContent && cmsContent.ctaButton && (
        <BNBox
          sx={{
            boxShadow: "0rem -0.3rem 1rem 0.1rem rgb(0 0 0 / 12%)",
            backdropFilter: "saturate(170%) blur(2rem)",
            backgroundColor: "rgba(255, 255, 255, 0.65)",
            padding: "1rem",
            display: "flex",
            alignItems: "center",
            width: "100%",
            position: "sticky",
            justifyContent: "center",
            bottom: 0,
            [theme.breakpoints.up("sm")]: {
              display: cmsContent.ctaButtonHidden?.smUp ? "none" : undefined,
            },
            [theme.breakpoints.down("sm")]: {
              display: cmsContent.ctaButtonHidden?.smDown ? "none" : undefined,
            },
          }}
        >
          <div>
            <Button {...cmsContent.ctaButton} />
          </div>
        </BNBox>
      )}
    </ErrorBoundary>
  );
};

export default CTAButton;
